module.exports = __webpack_public_path__ + "img/recorded.df46e71c.svg";